import { EventBus } from "App/IOC";

let activeInstanceId: string = "";

function Set( id: string ): void {
    activeInstanceId = id;

    Close();
}

function Close(): void {
    EventBus.Publish( "CloseInactiveSelectInstances", activeInstanceId );
}

export default {
    Close,
    Set
}
